var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_6",
    "data-name": "Grupo 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.366,
    height: 113.779,
    viewBox: "0 0 103.366 113.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M303.2,57.907v21.6a4.5,4.5,0,0,0,4.5,4.5h15.031a4.5,4.5,0,1,0,0-9H312.2v-17.1a4.5,4.5,0,1,0-9,0Z",
    transform: "translate(-255.686 -14.989)",
    fill: "#314164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M360.493,42.3a4.5,4.5,0,0,0,3.2-7.663l-10.12-10.25a4.5,4.5,0,0,0-6.406,6.324l10.12,10.251A4.488,4.488,0,0,0,360.493,42.3Z",
    transform: "translate(-261.629 -10.761)",
    fill: "#314164"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M251.355,71.161a48.717,48.717,0,0,0,18.159,37.946l-6.656,5.465a4.5,4.5,0,1,0,5.712,6.957l8.806-7.229a48.7,48.7,0,0,0,45.544,0l8.806,7.229a4.5,4.5,0,0,0,5.713-6.957l-6.659-5.465a48.768,48.768,0,0,0-26.132-86.528v-4.8h3.717a4.5,4.5,0,0,0,0-9H292.594a4.5,4.5,0,1,0,0,9h3.051v4.8a48.855,48.855,0,0,0-44.29,48.582Zm88.581,0a39.788,39.788,0,1,1-39.789-39.789,39.834,39.834,0,0,1,39.789,39.789",
    transform: "translate(-248.465 -8.773)",
    fill: "#314164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M259.415,24.381,249.3,34.633a4.5,4.5,0,0,0,6.407,6.324l10.12-10.251a4.5,4.5,0,0,0-6.407-6.324",
    transform: "translate(-247.998 -10.76)",
    fill: "#314164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a60abec36466aed762c7c57813c79a3f.svg";
export { ForwardRef as ReactComponent };